export default __webpack_public_path__ + "static/media/RuleOutLogo.907365ee.svg";